import axios from '../config/axiosConfig';
import apiKey from '@/service/constant/ApiKey';
import { AIR_URL } from './constant/BaseApiUrl';

export default class ListFlightService {
  getListFlight(payload) {
    return axios.post(`${AIR_URL}${apiKey.LIST_FLIGHT}`, payload);
  }

  charterService(payload) {
    return axios.post(`${AIR_URL}${apiKey.CHARTER}`, payload);
  }
}
